import { Schema } from "effect";

/**
 * A `DateTime.Utc` decoded from an ISO string. Effect 4 reuses the name `Schema.DateTimeUtc`
 * for a schema of the instance itself and names the string decoder
 * `Schema.DateTimeUtcFromString`; every field that uses this alias keeps decoding strings.
 * v3 documented the string as the shared `DateTimeUtc` component, so the encoded side keeps
 * that identifier and description.
 */
export const DateTimeUtcFromString = Schema.DateTimeUtcFromString.pipe(
  Schema.annotateEncoded({
    identifier: "DateTimeUtc",
    description: "a string to be decoded into a DateTime.Utc",
  })
);
